var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 147,
    viewBox: "0 0 119 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.2705 48.8168C83.1797 49.8363 84.2988 50.9313 85.6566 52.1061C90.1116 47.8536 93.2166 44.9173 93.2166 44.9173",
    stroke: "#0E3C6E",
    strokeWidth: 3.37501,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2705 77.1668C83.1797 78.1863 84.2988 79.2813 85.6566 80.4561C90.1116 76.2036 93.2166 73.2673 93.2166 73.2673",
    stroke: "#0E3C6E",
    strokeWidth: 3.37501,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2705 105.517C83.1797 106.536 84.2988 107.631 85.6566 108.806C90.1116 104.554 93.2166 101.617 93.2166 101.617",
    stroke: "#0E3C6E",
    strokeWidth: 3.37501,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3062 45.5248H67.1938",
    stroke: "#0E3C6E",
    strokeWidth: 4.05001,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3062 53.2873H43.2312",
    stroke: "#0E3C6E",
    strokeWidth: 4.05001,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3062 73.1998H67.1938",
    stroke: "#0E3C6E",
    strokeWidth: 4.05001,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3062 80.9623H43.2312",
    stroke: "#414042",
    strokeWidth: 4.05001,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3062 100.2H67.1938",
    stroke: "#0E3C6E",
    strokeWidth: 4.05001,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3062 107.962H43.2312",
    stroke: "#0E3C6E",
    strokeWidth: 4.05001,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M116.384 3.03325L3.37868 3.12472L3 144.042L116.604 143.848L116.607 3.96138",
    stroke: "#0E3C6E",
    strokeWidth: 4.05001,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8458 3V14.6002H40.2275V3H79.8458Z",
    stroke: "#414042",
    strokeWidth: 4.05001,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIllustration);
export default __webpack_public_path__ + "static/media/cardIllustration.b5c5c50b9270de5f2a8769ecd81d0035.svg";
export { ForwardRef as ReactComponent };